import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SpokeMstApi } from '../api/spoke-mst.api';
import { SpokeMst, SpokeMstData } from '../../../interfaces/masters/spoke-mst';

@Injectable()
export class SpokeMstService extends SpokeMstData {

  constructor(private api: SpokeMstApi) {
    super();
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  getById(url: string): Observable<SpokeMst> {
    return this.api.getById(url);
  }

  create(url: string, data: SpokeMst): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: SpokeMst): Observable<any> {
    return this.api.update(url, data);
  }

}
